import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
import SettingsContextProvider from '../src/context/settings/provider';

const root = ReactDOM.createRoot(
    document.getElementById('empriva-condoleanceregister-app') as HTMLElement
);

root.render(
    <React.StrictMode>
        <SettingsContextProvider>
            <App/>
        </SettingsContextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
